// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-upload[data-v-515ccd36]{display:inline-flex}.file-upload__file-icon[data-v-515ccd36]{margin-right:.5rem}.file-upload__label[data-v-515ccd36]{padding-left:0}.file-upload__label[data-v-515ccd36],.file-upload__button[data-v-515ccd36]{font-size:1rem}.file-upload__button[data-v-515ccd36]{padding:0 .35rem;text-decoration:underline}.file-upload__button[data-v-515ccd36]:hover{opacity:.8}input.file-btn[data-v-515ccd36]{display:none}", ""]);
// Exports
module.exports = exports;
